(function () {
  const initTabsWithProducts = () => {
    const tabsParent = document.querySelectorAll(".tabs-with-text");

    tabsParent.forEach(function (parent) {
      const tabs = parent.querySelectorAll(".twt__tabs-item");

      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          if (this.hasAttribute("data-active")) return;

          const tabsWrapper = this.closest(".twt__tabs").nextElementSibling;
          const tabsContent = tabsWrapper ? tabsWrapper.querySelectorAll(".twt__content-item") : [];
          const idx = Array.from(tabs).indexOf(this);

          this.parentElement.querySelector("[data-active]")?.removeAttribute("data-active");
          this.setAttribute("data-active", "");

          tabsContent.forEach(function (item) {
            item.style.display = "none";
          });
          if (tabsContent[idx]) {
            tabsContent[idx].style.display = "flex";
            tabsContent[idx].style.opacity = "0";
            requestAnimationFrame(function () {
              tabsContent[idx].style.transition = "opacity 0.3s ease";
              tabsContent[idx].style.opacity = "1";
            });
          }
        });
      });
    });

    tabsParent.forEach(function (elem) {
      const tabsSlider = elem.querySelector(".twt__tabs");
      const tabsPrev = elem.querySelector(".twt__prev");
      const tabsNext = elem.querySelector(".twt__next");

      let slider = new Swiper(tabsSlider, {
        slidesPerView: "auto",
        spaceBetween: 32,
        freeMode: true,
        navigation: {
          nextEl: tabsNext,
          prevEl: tabsPrev,
        },
        breakpoints: {
          990: {
            spaceBetween: 64,
          },
        },
        on: {
          afterInit: function () {
            let slidesWidth = 0;
            const offset = window.matchMedia("(min-width: 990px)").matches ? 64 : 32;

            this.slides.forEach(elem => {
              slidesWidth += elem.offsetWidth + offset;
            });

            slidesWidth -= offset;

            if (slidesWidth < this.el.offsetWidth) {
              this.el.querySelector('.twt__nav').style.display = 'none';
            } else {
              this.el.querySelector('.twt__nav').style.display = 'flex';
            }
          }
        }
      });
    });
  };

  const initSection = () => {
    const sections = document.querySelectorAll('.tabs-with-text');

    const sectionResizeObserver = new ResizeObserver((entries) => {
      initTabsWithProducts();
    });

    initTabsWithProducts();

    sections.forEach(item => {
      sectionResizeObserver.observe(item);
    });
  };

  initSection();

  document.addEventListener("shopify:section:load", function () {
    initSection();
  });
})();
